import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { TechPointService } from '@app/tech-points/_models/tech-point-service.model';

export interface FreeServiceDTO {
  serviceMobileId: number;
  name: string;
}

export interface DiscountDTO {
  discountText: string;
  discountKind: string;
  discountValue: number;
  discountTextColor: string;
}

export interface ActiveDiscountCampaignDTO {
  serviceMobileId: number;
  serviceName: string;
  hasDiscount: boolean;
  discount?: DiscountDTO;
  hasTrigger: boolean;
  freeServices?: FreeServiceDTO[];
}

export interface ActiveDiscountCampaignsResponseDTO {
  activeDiscountCampaigns: ActiveDiscountCampaignDTO[];
}

@Injectable({
  providedIn: 'root',
})
export class PromotionalCampaign {
  private activeDiscountCampaignsUrl = environment.apiBaseURL + '/promo-campaign-config/discount-campaigns/active';

  constructor(private http: HttpClient) {}

  public getActiveDiscountCampaigns(): Observable<ActiveDiscountCampaignsResponseDTO> {
    return this.http.get<ActiveDiscountCampaignsResponseDTO>(this.activeDiscountCampaignsUrl);
  }

  public isEligibleForFreeCampaign(
    service: TechPointService,
    paymentServiceTableData: TechPointService[],
    campaigns: ActiveDiscountCampaignDTO[] = []
  ): boolean {
    const triggerNames = campaigns
      .filter(c => c.hasTrigger)
      .map(c => c.serviceName);

    const hasTriggerSelected = paymentServiceTableData.some(s =>
      triggerNames.includes(s.serviceName!.valueOf() as string)
    );

    if (!hasTriggerSelected) {
      return false;
    }

    const freeNames: string[] = [];
    campaigns
      .filter((c: ActiveDiscountCampaignDTO) => c.hasTrigger && c.freeServices)
      .forEach((c: ActiveDiscountCampaignDTO) => c.freeServices!.forEach((fs: FreeServiceDTO) => freeNames.push(fs.name)));

    return freeNames.includes(service.serviceName!.valueOf() as string);
  }

  public getTriggerServiceDiscount(
    serviceName: string,
    campaigns: ActiveDiscountCampaignDTO[]
  ): DiscountDTO | null {
    const campaign = campaigns.find(c => c.serviceName === serviceName && c.hasDiscount && c.discount);
    return campaign?.discount ?? null;
  }
}
